<template>
    <div>
        <h2>{{ $t("dashboard.text_17") }}</h2>
        <div id="main_second"></div>
    </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    props: ["data"],
    data() {
        return {
            all_months: [
                this.$t("statistics.january"),
                this.$t("statistics.february"),
                this.$t("statistics.march"),
                this.$t("statistics.april"),
                this.$t("statistics.may"),
                this.$t("statistics.june"),
                this.$t("statistics.july"),
                this.$t("statistics.august"),
                this.$t("statistics.september"),
                this.$t("statistics.october"),
                this.$t("statistics.november"),
                this.$t("statistics.december"),
            ],
            myChart: null,
        };
    },
    mounted() {
        this.setChart();
        setTimeout(() => {
            if (this.myChart) {
                this.myChart.resize();
            }
        }, 2000);
    },
    methods: {
        setChart() {
            this.myChart = echarts.init(document.getElementById("main_second"));
            var options = {
                grid: {
                    top: "20px",
                    left: "20px",
                    right: "40px",
                    bottom: "20px",
                    containLabel: true,
                },
                backgroundColor: "#fff",
                tooltip: {
                    trigger: "item",
                    formatter: function (params) {
                        if (params.value > 4)
                            var yLabel =
                                params.value +
                                this.$t("statistics.graph_text1");
                        else if (params.value == 1)
                            var yLabel =
                                params.value +
                                this.$t("statistics.graph_text2");
                        else
                            var yLabel =
                                params.value +
                                this.$t("statistics.graph_text3");
                        return yLabel;
                    }.bind(this),
                    backgroundColor: "rgba(54, 58, 83, 0.88)",
                    textStyle: {
                        color: "#fff",
                    },
                    borderColor: "rgba(54, 58, 83, 0.88)",
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.labels(),
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#9CA3AF",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        //formatter: function (params) {
                        //    return params.split("/")[0];
                        //}.bind(this),
                        padding: [10, 10, 10, 10],
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#9CA3AF",
                        },
                    },
                    axisLabel: {},
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                },
                series: [
                    {
                        data: this.data,
                        type: "bar",
                        symbolSize: 7,
                        symbol: "circle",
                        barWidth: 10,
                        lineStyle: {
                            width: 5,
                            color: "#FBBF24;",
                        },
                        itemStyle: {
                            borderWidth: 0,
                            color: "#FBBF24",
                        },
                        areaStyle: {
                            color: "#FBBF24",
                        },
                    },
                ],
            };
            this.myChart.setOption(options);
            window.addEventListener("resize", this.myChart.resize);
        },

        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        labels() {
            var labels = [];
            var today = new Date();
            for (var i = 5; i >= 0; i -= 1) {
                var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
                labels.push(
                    (d.getMonth() + 1).toString() +
                        "/" +
                        d.getFullYear().toString()
                );
            }
            return labels;
        },
    },
};
</script>

<style lang="scss" scoped>
h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #212541;
}
#main_second {
    width: 100%;
    height: 420px;
    @media (max-width: 1600px) {
        height: 350px;
    }
    @media (max-width: 1400px) {
        height: 320px;
    }
    @media (max-width: 1200px) {
        height: 300px;
    }
}
</style>
